import {ApiModel} from "../../classes/api/class.api.model";

export class ApiCartItems extends ApiModel {
    cart_id;

    constructor(cart_id)
    {
        let fillable = [
            'cart_id',
        ];

        super(fillable, { cart_id: cart_id });

        this.cart_id = cart_id;
    }

    all()
    {
        return new window.Promise((resolve, reject) => {
            ApiModel.callAPI(route('api.cart.items.index', { cart_id: this.cart_id }))
                .then(items => {
                    resolve(items);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    products()
    {
        return new window.Promise((resolve, reject) => {
            let products = {};

            ApiModel.callAPI(route('api.cart.items.index', { cart_id: this.cart_id }))
                .then(items => {
                    for (const [key, item] of Object.entries(items)) {
                        /*
                        REGULAR PRODUCT
                         */
                        /*
                        if(isset(item.product.idx))
                        {
                            if(isset(products[item.product.idx+"-"+item.product.features.FEATURE_EVENT_INFOS.FEATURE_EVENT_UID]))
                            {
                                products[item.product.idx+"-"+item.product.features.FEATURE_EVENT_INFOS.FEATURE_EVENT_UID].quantity++;
                            }
                            else
                            {
                                products[item.product.idx+"-"+item.product.features.FEATURE_EVENT_INFOS.FEATURE_EVENT_UID] = item.product;
                                products[item.product.idx+"-"+item.product.features.FEATURE_EVENT_INFOS.FEATURE_EVENT_UID]['quantity'] = 1;
                            }
                        }*/
                        item.product.seatinfo = [];
                        item.product.seatinfo['section'] = null;
                        item.product.seatinfo['row'] = null;
                        item.product.seatinfo['seat'] = null;
                        products[item.idx] = item.product;
                    }
                    resolve(products);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    /*
    getProductQty(idx = "", cart = "")
    {
        if(idx !== "" && cart !== "")
        {
            let qty = 0;

            let found = Object.keys(cart).filter(function(key) {
                if(cart[key].product.idx === idx)
                {
                    return key;
                }
            });

            if (found.length > 0) {
                qty = cart[found[0]].product.quantity;
            }

            return qty;
        }
    }
    */
    create()
    {

    }

    delete(cart_item_id)
    {
        //
    }

    deleteByProductId(product_id)
    {

    }

}
